import { FormattedMessage } from 'react-intl';
import { Questions } from '../questions';
import { Waiver } from '../waivers';
import {
  AdditionalInformationContainer,
  SectionHeader,
  StepNumber,
  SectionTitle,
  FormFieldsContainer,
  QuestionsContainer,
  WaiverContainer,
} from './styles';

interface AdditionalInformationProps {
  questionsProps: any;
  waiverProps: any;
  showQuestions: boolean;
  showWaiver: boolean;
  stepNo: number;
  isLiveBooking?: boolean;
  borderless?: boolean;
  fields: any;
  errors: any;
  onChange?: (
    position: number,
    value: string,
    nameField: string,
    unitTypeId: number
  ) => void;
  onWaiverChange?: (value: boolean) => void;
}

export const AdditionalInformation = ({
  questionsProps,
  waiverProps,
  showQuestions,
  showWaiver,
  stepNo,
  isLiveBooking = false,
  borderless = false,
  fields,
  errors,
  onWaiverChange,
}: AdditionalInformationProps) => {
  const questionsPropsWithForm = {
    ...questionsProps,
    errors,
    renderBottomBorder: showWaiver,
    onChange: questionsProps?.onChange,
  };

  if (!showQuestions && !showWaiver) {
    return null;
  }

  const waiverQuestion = waiverProps
    ? {
        text: waiverProps.label || waiverProps.name || '',
        subtext: waiverProps.content || '',
        popup_link_name: waiverProps.name || '',
        popup_link_text: waiverProps.content || '',
        required: waiverProps.required || false,
        input_type: 'waiver',
      }
    : null;

  let waiverValue = '';
  const waiverAccepted = fields?.get('waiver_accepted');
  if (waiverAccepted === true) {
    waiverValue = 'yes';
  } else if (waiverAccepted === false) {
    waiverValue = 'no';
  }

  const waiverErrors = errors?.get('waiver_accepted') || [];

  const waiverOnChange = onWaiverChange
    ? (value: string) => {
        onWaiverChange(value === 'yes');
      }
    : undefined;

  return (
    <AdditionalInformationContainer
      isLive={isLiveBooking}
      borderless={borderless}
      data-testid="additional-information-section"
    >
      <SectionHeader>
        <StepNumber>{stepNo}</StepNumber>
        <SectionTitle>
          <FormattedMessage
            id="ADDITIONAL_INFORMATION"
            defaultMessage="Additional Information"
            description="Additional information section title"
          />
        </SectionTitle>
      </SectionHeader>

      <FormFieldsContainer borderless={borderless}>
        {showQuestions && (
          <QuestionsContainer hasWaiver={showWaiver}>
            <Questions {...questionsPropsWithForm} />
          </QuestionsContainer>
        )}

        {showWaiver && waiverQuestion && (
          <WaiverContainer>
            <Waiver
              question={waiverQuestion}
              value={waiverValue}
              onChange={waiverOnChange || (() => {})}
              errors={waiverErrors}
            />
          </WaiverContainer>
        )}
      </FormFieldsContainer>
    </AdditionalInformationContainer>
  );
};
